import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../Login/Login.js";
import LoginOtp from "../Login/LoginOtp.js";
import Register from "../Login/Register.js";
import RegisterOtp from "../Login/RegisterOtp.js";

const Home = lazy(() => import("../pages/Home/Home.js"));
const About = lazy(() => import("../pages/About/About.js"));
const OurInvention = lazy(() => import("../pages/OurInvention/OurInvention"));
const OurRole = lazy(() => import("../pages/OurRole/OurRole"));
const ShoppingCentre = lazy(() => import("../pages/ShoppingCentre/ShoppingCentre.js"));
const ContactUs = lazy(() => import("../pages/ContactUs/ContactUs.js"));
const Faq = lazy(() => import("../pages/FAQ/Faq.js"));
const Overview = lazy(() => import("../pages/Overview/Overview.js"));
const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard.js"));
const TermsOfUse = lazy(() => import("../pages/TermsOfUse/TermsOfUse.js"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy/PrivacyPolicy.js"));
const Copyright = lazy(() => import("../pages/Copyright/Copyright"));

const AppRoutes = () => {
  return (
    <Suspense fallback={<div style={{ minHeight: "40vh" }} aria-hidden="true" />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/our-invention" element={<OurInvention />} />
        <Route path="/our-role" element={<OurRole />} />
        <Route path="/shopping-centre" element={<ShoppingCentre />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login-otp" element={<LoginOtp />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register-otp" element={<RegisterOtp />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/copyright" element={<Copyright />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
